<div class="container" gaCategory="header_interactions">
  <div class="logo" [class.reverse-layout]="reverseLogoLayout">
    <a *ngIf="logoLink; else: logoRouterLink" [href]="logoLink" gaEvent="logo_link_visited" target="_blank"
       rel="noreferrer noopener">
      <ng-container *ngTemplateOutlet="logoContent"></ng-container>
    </a>
    <ng-template #logoRouterLink>
      <a routerLink="/home">
        <ng-container *ngTemplateOutlet="logoContent"></ng-container>
      </a>
    </ng-template>

    <ng-template #logoContent>
      <img *ngIf="logoIcon" class="icon" [src]="logoIcon" alt="Application Logo">
      <span class="label">{{ logoLabel }}</span>
    </ng-template>
  </div>

  <div class="filler"></div>
</div>
